import React, { createContext, useState } from 'react';
// import { useEffect } from 'react';
let Context = null;
const { Provider, Consumer } = Context = createContext();

const ExtraDataProvider = (props) => {
    const getCurrentTheme = localStorage.getItem("darkTheme");
    const [isDarkTheme, setIsDarkTheme] = useState(getCurrentTheme === 'false' ? false : true);
    if (getCurrentTheme === null) {
        localStorage.setItem("darkTheme", Boolean(false));
    }

    const [getChildBreadCrumb, setChildBreadCrumb] = useState();

    return (
        <Provider value={
            {
                isDarkTheme,
                getChildBreadCrumb,

                setIsDarkTheme,
                setChildBreadCrumb,
            }
        }>
            {props.children}
        </Provider>
    )

}

export { ExtraDataProvider, Consumer as UserConsumer, Context as ExtraDataContext };